// How long a just-completed signup waits for a pixel to appear. Long enough to
// cover "accept cookies, register immediately", short enough that the timer is
// gone well before the visitor does anything else.
const PIXEL_POLL_INTERVAL_MS = 300
const PIXEL_POLL_LIMIT_MS = 15_000

/**
 * Runs `send` once the pixel global exists.
 *
 * Pixel snippets are injected on consent (for a stored choice, once the browser
 * goes idle), so a signup right after accepting cookies can land before the
 * global exists. Firing into the gap is a silent no-op, so wait instead. On
 * giving up `send` never runs, so whatever it would consume (the dedup id)
 * stays in storage for a later conversion in this session.
 *
 * ponytail: polling, not an event — next/script gives no reliable hook for an
 * inline snippet. Switch to an onLoad callback if that changes.
 */
export const whenPixelReady = (
  isReady: () => boolean,
  send: () => void
): void => {
  if (isReady()) {
    send()

    return
  }

  let waited = 0
  const poll = window.setInterval(() => {
    waited += PIXEL_POLL_INTERVAL_MS

    if (isReady()) {
      window.clearInterval(poll)
      send()

      return
    }

    if (waited >= PIXEL_POLL_LIMIT_MS) {
      window.clearInterval(poll)
    }
  }, PIXEL_POLL_INTERVAL_MS)
}
